import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const customerWidgetSchema = yup.object({
  customerName: yup.string().required("Please input name"),
  customerPhoneNumber: yup
    .string()
    .matches(/^[0-9]+$/, "Phone number must contain only digits")
    .test("num", "Invalid phone number format", (val) => !val.startsWith("0"))
    .min(9, "Invalid phone number format")
    .max(11, "Invalid phone number format"),
  customerEmail: yup.string().required("Email is required"),
  customerGender: yup.string().required("Please select gender"),
  dobDay: yup
    .number()
    .typeError("Day is required")
    .required("Day is required")
    .min(1, "Day must be between 1 and 31")
    .max(31, "Day must be between 1 and 31"),
  dobMonth: yup
    .number()
    .typeError("Month is required")
    .required("Month is required")
    .min(1, "Invalid month")
    .max(12, "Invalid month"),
  dobYear: yup
    .number()
    .nullable()
    .transform((value, original) => (original === "" ? null : value))
    .min(1900, "Year must be 1900 or later")
    .max(new Date().getFullYear(), "Year cannot be in the future")
    .optional(),
});

export const useCustomerWidgetValidation = ({
  customerName,
  customerEmail,
  customerGender,
  customerPhoneNumber,
  dobDay,
  dobMonth,
  dobYear,
}) => {
  return useForm({
    resolver: yupResolver(customerWidgetSchema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      customerName,
      customerEmail,
      customerGender,
      customerPhoneNumber,
      dobDay,
      dobMonth,
      dobYear,
    },
  });
};
